"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/ExtendedWorkItem"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const ShareDisplay_1 = require("@Components/WorkItemV2/ShareDisplay");
const dayjs_1 = __importDefault(require("dayjs"));
const overclaim_share_display_helper_1 = require("@App/helpers/overclaim-share-display-helper");
require("./index.scss");
const navigation_1 = __importDefault(require("@App/navigation"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const is_overclaim_helper_1 = require("@App/helpers/is-overclaim-helper");
const mobx_react_1 = require("mobx-react");
const OverclaimExtendedWorkItem = (props) => {
    var _a, _b, _c, _d;
    const { rightsholderStore, overclaimSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { work, toCatalog } = props;
    const totalOverclaim = (0, overclaim_share_display_helper_1.OverclaimShareDisplayHelper)(work.totalKnownShares);
    const path = toCatalog
        ? navigation_1.default.rightholder.catalog.work(rightsholderStore.currentRightsholderId, (_a = work.propertyId) !== null && _a !== void 0 ? _a : 0)
        : navigation_1.default.rightholder.overclaim.view(rightsholderStore.currentRightsholderId, work.overclaimHeaderId);
    return (react_1.default.createElement("div", { className: 'overclaim-extended-work-item-wrapper' },
        react_1.default.createElement(ExtendedWorkItem_1.default, { work: work, catalogPath: path, fields: [
                {
                    title: 'Date Created',
                    value: (0, dayjs_1.default)((_b = work.overclaimCreationDate) !== null && _b !== void 0 ? _b : '')
                        .utc()
                        .format('MMMM DD, YYYY'),
                    tooltip: 'This is the date when the work went into overclaim.',
                },
                { title: 'MLC Song Code', value: work.songCode },
                {
                    title: 'Overclaim ID',
                    value: (_c = work.overclaimHeaderId) === null || _c === void 0 ? void 0 : _c.toString(),
                },
            ], secondaryFields: [
                {
                    title: 'Last Updated',
                    value: (0, dayjs_1.default)((_d = work.lastUpdated) !== null && _d !== void 0 ? _d : '')
                        .utc()
                        .format('MMMM DD, YYYY'),
                    tooltip: 'The most recent date when an update was made to this work.',
                },
            ], showOverclaimStatus: true, isBulkActionStarted: overclaimSearchStore.isOverclaimBulkActionStarted, isBulkActionDisabled: !(0, is_overclaim_helper_1.isOverclaimHelper)(work) || work.relinquished, bulkActionToggle: (overclaimHeaderId) => overclaimSearchStore.toggleOverclaimSelectionForBulkAction(overclaimHeaderId), isBulkActionSelected: (overclaimHeaderId) => !!overclaimHeaderId &&
                overclaimSearchStore.overclaimsSelectedForBulkAction.has(overclaimHeaderId) },
            react_1.default.createElement("div", { className: 'submitted-shares' },
                react_1.default.createElement(CustomToolTip_1.default, { title: 'Submitted Shares', info: 'The total percentage of shares currently being claimed on this work.' }),
                react_1.default.createElement(ShareDisplay_1.ShareDisplay, { share: work.totalKnownShares, overclaim: true })),
            work.overclaimStatusFilter !== 'RESOLVED' && (react_1.default.createElement("div", { className: 'total-overclaim' },
                react_1.default.createElement(CustomToolTip_1.default, { title: 'Total Overclaim', info: 'The percentage of shares that is over 100%.' }),
                react_1.default.createElement(ShareDisplay_1.ShareDisplay, { share: totalOverclaim, highlight: true, overclaim: true }))))));
};
exports.default = (0, mobx_react_1.observer)(OverclaimExtendedWorkItem);
